/** CoStar.Api.ListingAnalyticsSub.ViewModels.AdvertisingPerformanceReport.Website */
export var Website;
(function (Website) {
    Website[Website["None"] = 0] = "None";
    Website[Website["LoopNet"] = 1] = "LoopNet";
    Website[Website["CityFeet"] = 10] = "CityFeet";
    Website[Website["CityFeetBot"] = 11] = "CityFeetBot";
    Website[Website["Realla"] = 20] = "Realla";
    Website[Website["CityFeetNDBot"] = 21] = "CityFeetNDBot";
    Website[Website["CoStarProperty"] = 30] = "CoStarProperty";
    Website[Website["CTX"] = 31] = "CTX";
    Website[Website["Showcase"] = 40] = "Showcase";
    Website[Website["CoStarSuite"] = 50] = "CoStarSuite";
    Website[Website["CoStarSuite2"] = 60] = "CoStarSuite2";
})(Website || (Website = {}));
/** CoStar.Api.ListingAnalyticsSub.ViewModels.AdvertisingPerformanceReport.Path */
export var Path;
(function (Path) {
    Path[Path["None"] = 0] = "None";
    Path[Path["ListingProfile"] = 100] = "ListingProfile";
    Path[Path["SearchResults"] = 101] = "SearchResults";
    Path[Path["ContactBroker"] = 102] = "ContactBroker";
    Path[Path["EmailsSent"] = 103] = "EmailsSent";
    Path[Path["ProspectListEmailsSent"] = 104] = "ProspectListEmailsSent";
    Path[Path["EmailAlertsSent"] = 105] = "EmailAlertsSent";
    Path[Path["ListingPinProfile"] = 106] = "ListingPinProfile";
    Path[Path["CampaignEmailsSent"] = 107] = "CampaignEmailsSent";
    Path[Path["ViewsOfListingWebsite"] = 108] = "ViewsOfListingWebsite";
    Path[Path["ViewsOfListingVideo"] = 109] = "ViewsOfListingVideo";
})(Path || (Path = {}));
